<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap :key="forceUpdateKey">
      <v-toolbar class="main-tool-bar" scroll-target="#scrolling-home">
        <v-layout
          py-2
          ma-0
          row
          :wrap="$vuetify.breakpoint.xsOnly"
          align-center
          justify-center
        >
          <v-flex shrink mr-auto mb-3>
            <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly">
              {{ $t('employee.employees') }}
            </v-toolbar-title>
          </v-flex>
          <v-flex xs12 sm5 lg6 grow class="titleSearch">
            <v-text-field
              v-if="userPermissions['WATCH_COLAB']"
              v-model="filters.search"
              flat
              :label="$t('employee.search')"
              prepend-inner-icon="search"
              clearable
              solo-inverted
              @change="getEmployees"
              @click:clear="clearSearch"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 lg3 shrink>
            <clear-filters
              @click="removeFilters"
              v-if="filtersRemove"
            ></clear-filters>
            <div class="d-inline-block">
              <v-tooltip bottom justify-end>
                <template v-slot:activator="{ on }" justify-end>
                  <v-btn
                    v-on="on"
                    @click="modals.confirmDelete = true"
                    icon
                    v-if="userPermissions['DELETE_COLAB']"
                    :disabled="!(selected.length > 0)"
                  >
                    <v-icon color="primary">delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('employee.delete') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="toast.confirmMail = true"
                    icon
                    :disabled="!(selected.length > 0)"
                  >
                    <v-icon color="primary">send</v-icon>
                  </v-btn>
                </template>
                <span>Enviar invitación</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>

        <v-speed-dial
          v-if="userPermissions['WATCH_COLAB']"
          key="1"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
        >
          <template v-slot:activator>
            <v-tooltip
              right
              v-if="
                userPermissions['ADD_COLAB'] ||
                userPermissions['DOWNLOAD_COLAB']
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('employee.options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip right v-if="userPermissions['ADD_COLAB']">
            <v-btn
              color="gradiente"
              dark
              fab
              small
              slot="activator"
              @click="addEmployee"
            >
              <v-icon>person_add</v-icon>
            </v-btn>
            <span>{{ $t('employee.create_collaborator') }}</span>
          </v-tooltip>
          <v-tooltip right v-if="userPermissions['ADD_COLAB']">
            <v-btn
              @click="modals.import = true"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
            >
              <v-icon>note_add</v-icon>
            </v-btn>
            <span>{{ $t('employee.import_collaborators') }}</span>
          </v-tooltip>
          <v-tooltip right v-if="userPermissions['DOWNLOAD_COLAB']">
            <v-btn
              @click="exportEmployee"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>{{ $t('employee.download_collaborators') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              v-show="
                userPermissions['DOWNLOAD_COLAB'] &&
                (totalItemsFromBackend > 0 || selected.length > 0)
              "
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="showQrSizeModalAll"
            >
              <v-icon>qr_code</v-icon>
            </v-btn>
            <span>{{ $t('employee.download_qr_s') }}</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container fluid elevation-2 class="table-full">
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              ref="employeeTable"
              v-model="selected"
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              :total-items="totalItemsFromBackend"
              :items="employees"
              :loading="working.wEmployee"
              :pagination.sync="pagination"
              item-key="id"
              select-all
              :no-data-text="
                userPermissions['WATCH_COLAB']
                  ? working.wEmployee
                    ? 'Cargando'
                    : employees.length > 0
                    ? ''
                    : 'No hay colaboradores'
                  : 'No tienes permiso de ver colaboradores'
              "
            >
              <template v-slot:headers="props">
                <tr>
                  <th style="width: 78px; max-width: 78px; min-width: 78px">
                    <v-checkbox
                      v-if="userPermissions['DELETE_COLAB']"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 78px; max-width: 78px; min-width: 78px"
                  >
                    {{ $t('employee.photo') }}
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                    @click="changeSort(props.headers[1].value)"
                  >
                    {{ $t('employee.first_name') }}
                    <SortTableArrow
                      :is-active="props.headers[1].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left sortable_pick"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                    @click="changeSort(props.headers[2].value)"
                  >
                    {{ $t('employee.last_name') }}
                    <SortTableArrow
                      :is-active="props.headers[2].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 280px; max-width: 280px; min-width: 280px"
                  >
                    {{ $t('employee.email') }}
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 110px; max-width: 110px; min-width: 110px"
                  >
                    {{ $t('employee.qr_code') }}
                  </th>
                  <th
                    class="text-xs-center"
                    style="width: 185px; max-width: 185px; min-width: 185px"
                    v-if="userPermissions['BLOCK_COLAB_QR']"
                  >
                    {{ $t('employee.qr_status') }}
                  </th>
                  <th
                    style="
                      width: 200px;
                      max-width: 200px;
                      min-width: 200px;
                      position: relative;
                    "
                  >
                    <v-select
                      multiple
                      :items="
                        userPermissions['WATCH_COLAB']
                          ? props.headers[4].filterItems
                          : []
                      "
                      item-value="id"
                      :label="$t('employee.role')"
                      item-text="name"
                      outline
                      height="50"
                      v-model="filters.role"
                      :dense="$vuetify.breakpoint.xsOnly"
                      @change="getEmployees"
                    >
                      <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0">{{ item.name }}</span>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ filters.role.length - 1 }} otros)</span
                        >
                      </template>
                    </v-select>
                    <SortTableArrow
                      class="sort_arrow"
                      @click="changeSort(props.headers[4].value)"
                      :is-active="props.headers[4].value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                  <th
                    :style="
                      getUser &&
                      getUser.webRole &&
                      getUser.webRole.hierachy == 0
                        ? 'width: 150px; max-width: 150px; min-width: 150px;'
                        : 'width: 250px; max-width: 250px; min-width: 250px;'
                    "
                  ></th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td
                  class="text-xs-left"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                >
                  <v-checkbox
                    color="primary"
                    v-if="
                      userPermissions['DELETE_COLAB'] ||
                      userPermissions['UPDATE_COLAB']
                    "
                    v-model="props.selected"
                    primary
                    hide-details
                  ></v-checkbox>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 78px; max-width: 78px; min-width: 78px"
                >
                  <v-badge color="green" v-model="props.item.new != null">
                    <template v-slot:badge>
                      <span>N</span>
                    </template>
                    <span>
                      <v-icon
                        v-if="
                          props.item.imageStorage == null ||
                          props.item.imageStorage.miniObjUrl == null
                        "
                        >account_circle</v-icon
                      >
                      <v-avatar size="30" v-else color="grey lighten-4">
                        <img :src="props.item.imageStorage.miniObjUrl" />
                      </v-avatar>
                    </span>
                  </v-badge>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 200px; max-width: 200px; min-width: 200px"
                >
                  {{ props.item.firstName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 200px; max-width: 200px; min-width: 200px"
                >
                  {{ props.item.lastName }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 280px; max-width: 280px; min-width: 280px"
                >
                  {{ props.item.mail }}
                </td>
                <td
                  class="text-xs-left"
                  style="width: 110px; max-width: 110px; min-width: 110px"
                >
                  <v-btn
                    icon
                    v-if="props.item.qr"
                    @click="showQrSizeModal(props.item)"
                  >
                    <v-avatar
                      :tile="tile"
                      :size="avatarSize"
                      color="grey lighten-4"
                    >
                      <img
                        :key="props.item.id"
                        :src="'data:image/jpg;base64, ' + props.item.qr"
                        alt="avatar"
                      />
                    </v-avatar>
                  </v-btn>
                  <v-icon v-else>no_sim</v-icon>
                </td>

                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: green;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    userPermissions['BLOCK_COLAB_QR'] &&
                    props.item.qrEnabled == true
                  "
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="bloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock_open</v-icon>
                      </v-btn>
                    </template>
                    <span>Suspender QR</span>
                  </v-tooltip>
                  Activo
                </td>

                <td
                  class="text-xs-left"
                  style="
                    width: 185px;
                    max-width: 185px;
                    min-width: 185px;
                    color: red;
                    font-weight: bold;
                    text-align-last: left;
                  "
                  v-if="
                    userPermissions['BLOCK_COLAB_QR'] &&
                    props.item.qrEnabled == false
                  "
                >
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="desbloqQR(props.item)"
                        icon
                      >
                        <v-icon>lock</v-icon>
                      </v-btn>
                    </template>
                    <span>Activar QR</span>
                  </v-tooltip>

                  <v-tooltip right max-width="250px">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">Suspendido</span>
                    </template>
                    <span>{{ props.item.qrDisabledReason }}</span>
                  </v-tooltip>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 200px; max-width: 200px; min-width: 200px"
                >
                  {{ props.item.webRole.name }}
                </td>
                <td
                  class="text-xs-left"
                  v-if="userPermissions['UPDATE_COLAB']"
                  :style="
                    getUser && getUser.webRole && getUser.webRole.hierachy == 0
                      ? 'width: 150px; max-width: 150px; min-width: 150px;'
                      : 'width: 250px; max-width: 250px; min-width: 250px;'
                  "
                >
                  <v-tooltip bottom justify-end>
                    <template v-slot:activator="{ on }" justify-end>
                      <v-btn v-on="on" @click="editEmployee(props.item)" icon>
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('employee.edit_collaborator') }}</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <EmployeeModal
      :title="modals.title"
      v-model="modals.employee"
      :employee="select.employee"
      :roles="roles"
      v-on:created="createEmployee"
      v-on:updated="updateEmployee"
      :permits="userPermissions"
      @deletePhoto="deletePhoto"
    ></EmployeeModal>
    <desition
      @desition="$event ? sendEmployees() : ''"
      v-model="toast.confirmMail"
      title="Envío de correo"
      description="Se enviará correo a los colaboradores seleccionados.<br/><br/> ¿Deseas continuar con la operación?"
    ></desition>
    <desition
      @desition="$event ? deletEmployees() : ''"
      v-model="modals.confirmDelete"
      title="Eliminar colaborador"
      description="¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?"
    ></desition>
    <QRSizeModal
      :class="!QRSizeModal.value ? 'position-no' : ''"
      v-model="QRSizeModal.value"
      :value="QRSizeModal.value"
      :title="QRSizeModal.title"
      :coll="true"
      @desition="desitionSize"
      @desitionImg="getQrImgStudent"
      @archivoName="archivoName"
    ></QRSizeModal>
    <ImportColab
      v-on:correct="imported"
      v-model="modals.import"
      :roles="roles"
    ></ImportColab>
    <loading v-model="working.wLoading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <QRBlock
      v-model="blockQR"
      :student="select.employee"
      @updated="updateEmployee"
      :coll="true"
    ></QRBlock>
    <QRDesblock
      v-model="desblockQR"
      :student="select.employee"
      @updated="updateEmployee"
      :coll="true"
    ></QRDesblock>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { funciones } from '../../../Mixins/Funciones'
import { pdfMixin } from '../../../Mixins/PdfMixin'
import { _getUserPermissions } from '../../../utils/genericUtils.js'
import desition from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import QRBlock from '../../Modals/BloqQR'
import QRDesblock from '../../Modals/DesbloqQR'
import EmployeeModal from '../../Modals/EmployeeModal.vue'
import ImportColab from '../../Modals/ImportColab'
import QRSizeModal from '../../Modals/QRModalStd'
import ClearFilters from '../../Tools/ClearFilters.vue'
import SortTableArrow from '../../Tools/SortTableArrow.vue'

export default {
  components: {
    EmployeeModal,
    ImportColab,
    loading,
    success,
    error,
    desition,
    QRSizeModal,
    ClearFilters,
    QRBlock,
    QRDesblock,
    SortTableArrow,
  },
  mixins: [funciones, pdfMixin],
  data: () => ({
    buttonFab: {
      fab: false,
      hidden: false,
    },
    filters: {
      size: 25,
      space: false,
      offset: 0,
      orderBy: 'LAST_NAME',
      orderType: 'ASC',
      search: '',
      role: [],
    },
    working: {
      wEmployee: false,
      wLoading: false,
    },
    toast: {
      success: false,
      failed: false,
      confirmMail: false,
    },
    employees: [],
    roles: [],
    headers: [
      {
        text: 'Foto',
        align: 'center',
        value: 'img',
      },
      {
        text: 'Nombre',
        align: 'center',
        value: 'NAME',
        filterItems: [],
      },
      {
        text: 'Apellidos',
        value: 'LAST_NAME',
        align: 'center',
        filterItems: [],
      },
      { text: 'Correo', value: 'mail', filterItems: [], align: 'center' },
      { text: 'Rol', value: 'ROLE', filterItems: [], align: 'center' },
      {
        text: 'Institución',
        value: 'branch.name',
        filterItems: [],
        align: 'center',
      },
      {
        text: '',
        value: 'actions',
        align: 'center',
      },
    ],
    selected: [],
    select: {
      employee: null,
    },
    modals: {
      title: '',
      employee: false,
      import: false,
      confirmDelete: false,
    },
    QRSizeModal: {
      title: '',
      value: '',
      parent: null,
    },
    allQrs: false,
    avatarSize: '30px',
    tile: false,
    rolesJson: [],
    totalItemsFromBackend: 0,
    documentName: '',
    pagination: {
      sortBy: 'NAME',
      descending: false,
      total: 0,
      rowsPerPage: 25,
    },
    blockQR: false,
    desblockQR: false,
    userPermissions: {},
    possibleUserModulePermissions: {
      WATCH_COLAB: 'WATCH_COLAB',
      ADD_COLAB: 'ADD_COLAB',
      UPDATE_COLAB: 'UPDATE_COLAB',
      BLOCK_COLAB_QR: 'BLOCK_COLAB_QR',
      DELETE_COLAB: 'DELETE_COLAB',
      DOWNLOAD_COLAB: 'DOWNLOAD_COLAB',
    },
    /**KEY TO FORCE UPDATE COMPONENTS */
    forceUpdateKey: 0,
  }),
  watch: {
    getBranch() {
      if (this.userPermissions['WATCH_COLAB'] && !this.employees.length > 0) {
        this.getEmployees()
        this.getTools()
      }
    },
    getUser() {
      this.mapPermits()
      /** RETRY ATTEMP */
      const maxAttemps = 2
      let retryAttemp = 1
      const a = setInterval(() => {
        if (this.userPermissions['WATCH_COLAB'] && this.getBranch.id) {
          this.getEmployees()
          this.getTools()
        }
        if (
          retryAttemp >= maxAttemps ||
          (this.userPermissions['WATCH_COLAB'] && this.getBranch.id)
        ) {
          clearInterval(a)
        }
        retryAttemp++
      }, 300)
    },
    pagination: {
      handler() {
        if (
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          this.getEmployees()
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
    }

    if (
      // this.getBranch.id != null &&
      this.userPermissions['WATCH_COLAB']
      // !this.employees.length > 0
    ) {
      this.getEmployees()
      this.getTools()
    }
  },
  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    deletePhoto(id) {
      this.working.wLoading = true
      this.$store
        .dispatch('employee/deleteImage', id)
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.modals.employee = false
          this.getEmployees()
        })
        .catch((error) => {
          console.log(error)
          this.working.wLoading = false
          this.toast.failed = true
        })
    },
    archivoName(e) {
      this.documentName = e.coll
    },
    getQrImgStudent() {
      this.QRSizeModal.value = false
      const params = {
        webRoleIds: this.filters.role,
      }
      let name = ''

      if (this.filters.search != '') {
        params.search = ''
        params.search = this.filters.search
      }
      if (this.selected.length > 0) {
        params.webAdminIds = []
        for (let a = 0; a < this.selected.length; a++) {
          params.webAdminIds.push(this.selected[a].id)
          if (params.webAdminIds.length == 1) {
            for (let a = 0; a < this.documentName.length; a++) {
              if (this.documentName[a] == 'webRole') {
                name = name + this.selected[a].webRole.name + '-'
              }
              if (this.documentName[a] == 'firstName') {
                name = name + this.selected[a].firstName + '-'
              }
              if (this.documentName[a] == 'lastName') {
                name = name + this.selected[a].lastName + '-'
              }
            }
          }
        }
      }
      if (this.QRSizeModal.parent != null) {
        for (let a = 0; a < this.documentName.length; a++) {
          if (this.documentName[a] == 'webRole') {
            name = name + this.QRSizeModal.parent.webRole.name + '-'
          }
          if (this.documentName[a] == 'firstName') {
            name = name + this.QRSizeModal.parent.firstName + '-'
          }
          if (this.documentName[a] == 'lastName') {
            name = name + this.QRSizeModal.parent.lastName + '-'
          }
        }
        if (!params.webAdminIds) {
          params.webAdminIds = []
          params.webAdminIds.push(this.QRSizeModal.parent.id)
        } else {
          if (params.webAdminIds.find((a) => a == this.QRSizeModal.parent.id)) {
          } else {
            params.webAdminIds.push(this.QRSizeModal.parent.id)
          }
        }
      }

      for (let a = 0; a < this.documentName.length; a++) {
        if (this.documentName[a] == 'webRole') {
          params.role = true
        }
        if (this.documentName[a] == 'firstName') {
          params.firstName = true
        }
        if (this.documentName[a] == 'lastName') {
          params.lastName = true
        }
      }

      this.working.wLoading = true
      this.$store
        .dispatch('employee/getQrImgCollaborator', params)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          if (
            (params.webAdminIds && params.webAdminIds.length == 1) ||
            this.totalItemsFromBackend == 1
          ) {
            if (this.totalItemsFromBackend == 1) {
              for (let a = 0; a < this.documentName.length; a++) {
                if (this.documentName[a] == 'webRole') {
                  name = name + this.employees[0].webRole.name + '-'
                }
                if (this.documentName[a] == 'firstName') {
                  name = name + this.employees[0].firstName + '-'
                }
                if (this.documentName[a] == 'lastName') {
                  name = name + this.employees[0].lastName + '-'
                }
              }
            }
            name = name.substring(0, name.length - 1)
            a.download = name + '.png'
          } else {
            a.download = 'ColaboradoresQR.zip'
          }
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.working.wLoading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    bloqQR(employee) {
      this.select.employee = employee
      this.blockQR = true
    },
    desbloqQR(employee) {
      this.select.employee = employee
      this.desblockQR = true
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    exportEmployee() {
      const req = {
        search: this.filters.search,
        roleIds: this.filters.role,
        collaboratorIds:
          this.selected.length === 0
            ? undefined
            : this.selected.map((e) => e.id),
        size: this.selected.length === 0 ? 0 : undefined,
      }

      this.working.wLoading = true
      this.$store
        .dispatch('employee/getColaboratorByBranchToCsv', req)
        .then((response) => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'colaboradores.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          console.log(error)
          this.working.wLoading = false
        })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.employeeTable.filteredItems.slice()
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers)

      cf.registerFilter('search', function (searchWord, items) {
        if (searchWord == null || searchWord.trim() === '') return items
        var transformMap = {
          a: '[aá]',
          e: '[eé]',
          i: '[ií]',
          o: '[oó]',
          u: '[uí]',
          A: '[AÁ]',
          E: '[EÉ]',
          I: '[IÍ]',
          O: '[OÓ]',
          U: '[UÚ]',
        }
        var search = searchWord ? searchWord : ''
        search = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        for (var key in transformMap) {
          search = search.replace(key, transformMap[key])
        }
        var matcher = new RegExp(search, 'i')
        return items.filter((item) => {
          return matcher.test(
            [
              item.firstName,
              item.lastName,
              item.firstName + ' ' + item.lastName,
              item.mail,
            ].join()
          )
        }, searchWord)
      })

      cf.registerFilter('role', function (role, items) {
        if (role.length == 0) return items

        return items.filter((item) => {
          for (var r in role) {
            if (item.webRole.name.toLowerCase() === role[r].toLowerCase()) {
              return true
            }
          }
          return false
        }, role)
      })

      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters()
    },
    addEmployee(event = null) {
      this.select.employee = null
      this.modals.title = this.$t(
        'employee.edit_employee_modal.create_collaborator'
      )
      this.modals.employee = true
    },
    createEmployee(event) {
      event.new = true
      this.employees.unshift(event)
      this.getEmployees()
      this.$forceUpdate()
    },
    updateEmployee(event) {
      this.employees.splice(
        this.employees.indexOf(this.select.employee),
        1,
        event
      )
      this.select.employee = null
      this.getEmployees()
      this.$forceUpdate()
    },
    editEmployee(employee) {
      this.select.employee = employee
      this.modals.employee = true
      this.modals.title = this.$t(
        'employee.edit_employee_modal.edit_collaborator'
      )
    },
    async getEmployees() {
      const temp = {
        ...this.filters,
        roleIds: this.filters.role,
      }

      this.working.wEmployee = true
      try {
        const response = await this.$store.dispatch(
          'employee/getEmployees',
          temp
        )

        if (response.data.code === 404) {
          this.working.wEmployee = false
          this.employees = []
          this.totalItemsFromBackend = 0
          return
        }

        this.working.wEmployee = false
        this.employees = response.data.data
        this.totalItemsFromBackend = response.data.total
      } catch (error) {
        this.employees = []
        this.totalItemsFromBackend = 0
        this.working.wEmployee = false
        console.log(error)
      }
    },
    async getTools() {
      try {
        const response = await this.$store.dispatch('employee/getTools')

        this.headers[4].filterItems = response.data.entity.roles
        this.rolesJson = response.data.entity.roles
        this.roles = response.data.entity.roles
      } catch (error) {
        console.log(error)
      }
    },
    imported(event) {
      for (var e in event) {
        event[e].new = true
        this.employees.unshift(event[e])
      }
    },
    deletEmployees() {
      this.working.wLoading = true
      this.$store
        .dispatch('employee/deleteEmployee', this.selected)
        .then((response) => {
          for (var e in this.selected) {
            this.employees.splice(this.employees.indexOf(this.selected[e]), 1)
          }
          this.selected = []
          this.working.wLoading = false
          this.toast.success = true
          this.getEmployees()
          this.$forceUpdate()
        })
        .catch((error) => {
          this.toast.failed = true
          this.working.wLoading = false
        })
    },
    sendEmployees() {
      var counter = 0
      this.working.wLoading = true
      for (var emp of this.selected) {
        this.$store
          .dispatch('employee/sendEmployee', emp.id)
          .then((response) => {
            counter++
            if (this.selected.length == counter) {
              this.working.wLoading = false
              this.toast.success = true
            }
          })
          .catch((error) => {
            counter++
            if (this.selected.length == counter) {
              this.working.wLoading = false
              this.toast.failed = true
            }
          })
      }
    },
    async desitionSize(e) {
      this.QRSizeModal.value = false
      if (!e.value) {
        this.allQrs = false
        return
      }
      if (this.QRSizeModal.parent != null) {
        if (this.selected.find((a) => a.id === this.QRSizeModal.parent.id)) {
        } else {
          this.selected.push(this.QRSizeModal.parent)
        }
      }

      if (this.selected.length > 0) {
        await this.downloadEmployeeMasiveQR(
          this.selected,
          e.size,
          this.getBranch,
          e.space
        )
      } else {
        this.downloadEmployeeAllQR(e.size, e.space)
      }

      if (this.QRSizeModal.parent != null) {
        var a = this.selected.indexOf(this.QRSizeModal.parent)
        this.selected.splice(a, 1)
      }
      this.allQrs = false
      this.QRSizeModal.parent = null
    },
    downloadEmployeeAllQR(size, space) {
      const temp = {
        ...this.filters,
        roleIds: this.filters.role,
      }

      this.working.wLoading = true
      this.allQrs = false

      this.$store
        .dispatch('employee/getEmployees', temp)
        .then((response) => {
          this.downloadEmployeeMasiveQR(
            response.data.data,
            size,
            this.getBranch,
            space
          )
          this.working.wLoading = false
          this.toast.success = true
        })
        .catch((error) => {
          this.toast.failed = true
          this.working.wLoading = false
          console.log(error)
        })
    },
    showQrSizeModal(e) {
      this.QRSizeModal.title = this.$t('employee.modal_qr.qr_download')
      this.QRSizeModal.value = true
      this.QRSizeModal.parent = e
    },
    showQrSizeModalAll() {
      this.allQrs = true
      this.QRSizeModal.title = this.$t('employee.modal_qr.qr_download')
      this.QRSizeModal.value = true
      this.QRSizeModal.parent = null
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      this.QRSizeModal.value = false
      this.modals.employee = false
      this.modals.import = false
      this.modals.confirmDelete = false
      this.toast.confirmMail = false
      this.QRSizeModal.parent = null
      this.$forceUpdate()
    },
    clearSearch() {
      this.filters.search = ''
      this.getEmployees()
    },
    removeFilters() {
      this.filters.search = ''
      this.filters.role = []
      this.selected = []
      this.QRSizeModal.parent = null
      this.getEmployees()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    filtersRemove() {
      return (
        this.filters.role.length || this.filters.search || this.selected.length
      )
    },
    filteredEmployees() {
      return this.employees.filter((employee) => employee.id != this.getUser.id)
    },
    ...mapGetters(['getBranch', 'getUser']),
  },
}
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
</style>
<style scoped>
.sortable_pick {
  cursor: pointer;
}
.sort_arrow {
  display: inline-block;
  width: 10px;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(90%);
}
.main-tool-bar {
  z-index: 1;
}
::v-deep .main-tool-bar .v-toolbar__content {
  height: auto !important;
}
::v-deep .table-full .v-datatable.v-table > tbody {
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
}
</style>
